import React from "react";
import { useShowActionsMenu } from "../../../../components/UI/ActionsMenu/hooks/useShowActionsMenu";
import { IconButton } from "../../../../components/UI/IconButton/IconButton";

export const EditMapActions = ({ map, editMap, handleChangeMapName }) => {
  const [showMenuActions] = useShowActionsMenu();

  const menuItems = [];

  menuItems.push({
    text: "Change name",
    onClick: () => handleChangeMapName(map),
    map,
  });
  menuItems.push({
    text: "Change status",
    onClick: () => editMap(map, 'archived', !map.archived),
    map,
  });

  const menuOptions = {
    items: menuItems,
    minMenuHeight: 35 * menuItems.length,
    offsetY: 7,
  };

  return (
    <div className="buttons-block">
      <IconButton
        iconName="options"
        className="btn-primary IconButton primary trigger-actions-menu"
        onClick={showMenuActions(menuOptions)}
      />
    </div>
  );
};
